import React from 'react'

function Footer() {
  return (
    <div className='p-3 lg:p-12 h-[50vh] md:h-[30vh] lg:h-[50vh] bg-orange flex flex-col md:flex-row gap-3'>
      <div className='w-full md:w-1/2 h-1/2 md:h-full'>
        <iframe className='w-full h-full'
          title='location'
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d428.62365811557527!2d81.07258880663845!3d20.59417077685057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a2ebbe22b15113f%3A0x4abe8898bea40992!2sShiv%20Traders!5e0!3m2!1sen!2sin!4v1708580384362!5m2!1sen!2sin"
          allowfullscreen="" 
          loading="lazy" 
          referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
      <div className='w-full md:w-1/2 md:full flex flex-col md:items-start md:justify-center'>
        <div className='mb-3 flex items-center gap-2'>
          <img className='h-[20px] md:h-[40px] w-[20px] md:w-[40px] invert'
            src="https://res.cloudinary.com/dr61rg1rq/image/upload/v1708581177/Shiv-Traders/Assets/Icons/yqpayyluelmz0iimw09f.png"
            alt="address" />
          <h1 className='text-xl md:text-3xl text-white font-open-sans font-medium'>Address</h1>
        </div>
        <p className='ml-4 text-xl md:text-2xl text-white font-roboto font-light'>Main Road, Chikhlakasa</p>
        <p className='ml-4 text-xl md:text-2xl text-white font-roboto font-light'>Dalli Rajhara, Dist. Balod</p>
        <p className='ml-4 text-xl md:text-2xl text-white font-roboto font-light'>Chhattisgarh, 491228</p>
        <div className='mt-4 flex items-center gap-1'>
          <img className='h-[20px] md:h-[30px] w-[20px] md:w-[30px] invert'
            src="https://res.cloudinary.com/dr61rg1rq/image/upload/v1708581177/Shiv-Traders/Assets/Icons/lmxqy2j79scaif00x23p.png"
            alt="phone" />
          <h1 className='text-xl md:text-2xl text-white font-open-sans font-medium'>+91 9589579425</h1>
        </div>
      </div>
    </div>
  )
}

export default Footer